// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import util from '@/util/'
import Element from 'element-ui'
import '@/assets/element-variables.scss'
import '@/pages/common/Header'
import '@/pages/common/MyUpload'
//import '@/pages/common/Footer' //todo: see the header
import '@/pages/bid/components/inventory'
import '@/pages/bid/components/inventory_BigData'
import '@/components/SelectCategory'
import '@/pages/order/components/contractDialog'
import '@/pages/order/components/priceChooseDialog'

// Element.TableColumn.props.showOverflowTooltip ={type:Boolean, default: true}
// Element.Table.props.border ={type:Boolean, default: true}
Vue.use(Element);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (util.isPublicRoute(to.name)) { //判断是否是不需要登录就可以访问的路由
        next()
    } else {
        if (!window.sessionStorage.getItem('regenerate_token_flag')) {
            next()
        } else {
            if (this.isPopDialog) return; //如果为true，就不弹了
            Vue.prototype.$alert('登录超时，请重新登录！', {
                callback: action => {
                    this.isPopDialog = true;
                    let currentUrl = (window.location.href).split('?')[0];
                    next({
                        path: '/login/' + encodeURIComponent(currentUrl),
                        query: { redirect: to.fullPath }
                    })
                }
            })
        }
    }
});

Vue.prototype.$http = axios.create({
    baseURL: util.baseUrl
});
Vue.prototype.$http.interceptors.request.use(config => { //前端请求
    // 在发送请求之前做些什么，比如设置token
    config.headers.token = window.sessionStorage.getItem('token') || '';
    config.headers.refresh_token = window.sessionStorage.getItem('refresh_token') || '';
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
Vue.prototype.$http.interceptors.response.use(res => { // 后台响应
    //if(!util.isPublicRoute(app.$route.name) && ~res.data.message.indexOf('未登录')){
    //    app.$router.push(`/login?msg=${res.data.message}&redirect=${app.$route.fullPath}`)
    //}window.sessionStorage.getItem('regenerate_token_flag')
    // console.log('响应',res,res.headers.regenerate_token_flag)
    //  regenerate_token_flag 值为1，可以刷新免登录，重新赋值token，值为2，需要重新登录
    if (res.headers.token && res.headers.regenerate_token_flag != 2) {
        window.sessionStorage.setItem('token', res.headers.token);
        this.isLogin = true;
    }
    if (res.headers.refresh_token && res.headers.regenerate_token_flag != 2) {
        window.sessionStorage.setItem('refresh_token', res.headers.refresh_token);
        this.isLogin = true;
    }
    if (res.headers.regenerate_token_flag == 2) {
        window.sessionStorage.setItem('token', '');
        window.sessionStorage.setItem('refresh_token', '');
        this.isLogin = false;
    }
    return res;
}, error => {
    // alert('加载失败')
    // console.log('失效',error)
    /* window.sessionStorage.setItem('token','');
     window.sessionStorage.setItem('refresh_token','');
     this.isLogin = false;*/
    return Promise.reject(error);
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data: {
        activeIndex: 'home',
        isLogin: false, //判断是否是登录状态，可以通过$root.isLogin 来获取或者修改；
        uploadUrl: '', //上传接口ipa地址
        downloadUrl: '', //下载接口ipa地址
        baseUrl: '', //当前服务器地址；
        loading: false,
        isPopDialog: false, //是否可以弹出登录超时的dialog；
        inLoginPage: false, //是否已经弹出过token不存在的dialog

        gc_category: 'L001',
        wzsb_category: 'L002',
        yxtg_category: 'L003',
        wyfw_category: 'L004',
        wyfwba_category: 'L0040010001',
        wyfwbj_category: 'L0040010002',
        wywb_category: 'L005',
        wywb_kt_category: 'L0050010001',
        wywb_pds_category: 'L0050010002',
        sj_category: 'L006',
        gw_category: 'L007',
        xx_category: 'L008',
        xz_category: 'L009',
        tableHeaderStyle: {
            'background-color': '#F6F6F6',
            'text-align': 'left',
            'height': '50px',
            'line-height': '10px',
        },
        tableCellStyle: {
            'text-align': 'left'
        },
        treeProps: {
            children: 'children',
            label: 'categoryName',
            disabled: function(data, node) {
                return data.categoryLevel != 3;
            }
        },
        pageSizesArr: [10, 20, 50, 100, 200],
        numberFilter: "value=value.replace(/[^\\d.]/g,'').replace(/\\.{2,}/g, '.').replace(/^\\./g, '').replace('.', '$#$').replace(/\\./g, '').replace('$#$', '.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3');if(value.indexOf('.') < 0 && value != '') { value = parseFloat(value) }",
        numberFilter1: "value=value.replace(/[^\\d]/g,'')",
        numberFilter2: "value=value.replace(/[^\\d.]/g,'');if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}",
        numberFilter3: "value=value.replace(/[^\\d.]/g,'');if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}",
        numberFilter4: "value=value.replace(/[^\\d.]/g,'').replace(/\\.{2,}/g, '.').replace(/^\\./g, '').replace('.', '$#$').replace(/\\./g, '').replace('$#$', '.').replace(/^*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3');if(value.indexOf('.') < 0 && value != '') { value = parseFloat(value) }",
        numberFilter6: "value=value.replace(/[^\\d.]/g,'').replace(/\\.{2,}/g, '.').replace(/^\\./g, '').replace('.', '$#$').replace(/\\./g, '').replace('$#$', '.').replace(/^(\\-)*(\\d+)\\.(\\d\\d\\d\\d\\d\\d).*$/, '$1$2.$3');if(value.indexOf('.') < 0 && value != '') { value = parseFloat(value) }",
        qing_dan_page_url: '/v1/outerformflowHS/getWFlowFormListPage'
    },
    methods: {
        // 两位小数处理
        rounding(value) {
            if (value) {
                return parseFloat(value).toFixed(2)
            } else {
                return value
            }
        },
        moneyFormat(val) {
            let valF;
            if (val) {
                if (val >= 100000000) {
                    valF = this.accDiv(val, 100000000);
                    return valF ? valF.toFixed(2) + '亿' : '';
                }
                if (val >= 10000) {
                    valF = this.accDiv(val, 10000);
                    return valF ? valF.toFixed(2) + '万' : '';
                }
            }
            return val;
        },
        accMinus(arg1, arg2) {
            try {
                var r1, r2, m;

                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }

                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }

                m = Math.pow(10, Math.max(r1, r2));

                return (this.accMul(arg1, m) - this.accMul(arg2, m)) / m;
            } catch (e) {
                return 0
            }
        },
        accAdd(arg1, arg2) {
            try {
                var r1, r2, m;

                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }

                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }

                m = Math.pow(10, Math.max(r1, r2));

                return (this.accMul(arg1, m) + this.accMul(arg2, m)) / m;
            } catch (e) {
                return 0
            }

        },

        //javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
        accMul(arg1, arg2) {
            try {
                arg1 = arg1 || 0;
                arg2 = arg2 || 0;
                var m = 0,
                    s1 = arg1.toString(),
                    s2 = arg2.toString();

                try {
                    m += s1.split(".")[1].length
                } catch (e) {}

                try {
                    m += s2.split(".")[1].length
                } catch (e) {}

                return Number((Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)).toFixed(2));
            } catch (e) {
                return 0
            }

        },
        // 除法
        mathDiv(arg1, arg2, num) {
            arg1 = arg1 || 0;
            arg2 = arg2 || 0;
            num = num || 2
            var t1 = 0,
                t2 = 0,
                r1, r2;
            try {
                t1 = arg1.toString().split(".")[1].length
            } catch (e) {}
            try {
                t2 = arg2.toString().split(".")[1].length
            } catch (e) {}
            r1 = Number(arg1.toString().replace(".", ""));
            r2 = Number(arg2.toString().replace(".", ""));
            let result = Number((r1 / r2) * Math.pow(10, t2 - t1)).toFixed(num)
            return result;
            // let add = (r1 / r2) * Math.pow(10, t2 - t1)
            // return (r1 / r2) * Math.pow(10, t2 - t1).toFixed(num)


            //获取小数点后的计算值
            // var result = ((r1 / r2) * Math.pow(10, t2 - t1)).toString()
            // var result2 = result.split(".")[1];
            // result2 = result2 ? result2.substring(0, digit > result2.length ? result2.length : digit) : '';
            // return Number(result.split(".")[0] + "." + result2) ? Number(result.split(".")[0] + "." + result2).toFixed(2) : '';

            // if (!arg1) return '';
            // if (!arg2) return '';
            // var t1 = 0,
            //     t2 = 0,
            //     num = 2
            // r1, r2;
            // try {
            //     t1 = arg1.toString().split(".")[1].length
            // } catch (e) {}
            // try {
            //     t2 = arg2.toString().split(".")[1].length
            // } catch (e) {}
            // r1 = Number(arg1.toString().replace(".", ""));
            // r2 = Number(arg2.toString().replace(".", ""));
            // return (r1 / r2) * Math.pow(10, t2 - t1).toFixed(num)
        },
        accMuls(arg1, arg2, arg3) {
            if (!arg3) {
                arg3 = 1
            }
            try {
                let temp = this.accMul(arg1, arg2)
                return this.accMul(temp, arg3)
            } catch (e) {
                return 0
            }
        },

        accDiv(arg1, arg2, digit) {
            try {
                var t1 = 0,
                    t2 = 0,
                    r1, r2;
                try {
                    t1 = arg1.toString().split(".")[1].length
                } catch (e) {}
                try {
                    t2 = arg2.toString().split(".")[1].length
                } catch (e) {}
                r1 = Number(arg1.toString().replace(".", ""))
                r2 = Number(arg2.toString().replace(".", ""))
                    //获取小数点后的计算值
                var result = ((r1 / r2) * Math.pow(10, t2 - t1)).toString()
                var result2 = result.split(".")[1];
                result2 = result2 ? result2.substring(0, digit > result2.length ? result2.length : digit) : '';
                return Number(result.split(".")[0] + "." + result2);
            } catch (e) {
                return 0
            }
        },

        dateAddDays(dataStr, dayCount) {
            var strdate = dataStr; //日期字符串
            var isdate = new Date(strdate.replace(/-/g, "/")); //把日期字符串转换成日期格式
            isdate = new Date((isdate / 1000 + (86400 * dayCount)) * 1000); //日期加1天
            var pdate = isdate.getFullYear() + "-" + (isdate.getMonth() + 1) + "-" + (isdate.getDate()); //把日期格式转换成字符串

            return pdate;
        },
        //补0操作
        getzf(num) {
            if (parseInt(num) < 10) {
                num = '0' + num;
            }
            return num;
        },
        /*日期格式化*/
        getMyDate(str, type) {
            if (!str) {
                return '';
            }
            let oDate = new Date();
            let ds = str.split(" ")[0].split("-");
            let ts = str.split(" ")[1].split(":");
            oDate.setFullYear(ds[0], ds[1] - 1, ds[2]);
            oDate.setHours(ts[0], ts[1], ts[2], 0);
            let oYear = oDate.getFullYear(),
                oMonth = oDate.getMonth() + 1,
                oDay = oDate.getDate(),
                oHour = oDate.getHours(),
                oMin = oDate.getMinutes(),
                oSen = oDate.getSeconds();
            let oTime = "";
            if (type == 1) { //yyyy-MM-dd HH:mm:ss
                oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSen); //最后拼接时间
            } else if (type == 2) { //yyyy-MM-dd
                oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay); //最后拼接时间
            } else if (type == 3) { //yyyy-MM-dd HH:mm:00
                oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':00'; //最后拼接时间
            } else if (type == 4) {
                oTime = oYear + '年';
            }
            return oTime;
        },
        checkLoginName(value, fn) {
            let that = this;
            // that.loading = true;
            // that.getHttp('/v1/sSuppliers/public/checkLoginName/' + value + '/1', function (res) {
            //     !!fn && fn(res.data);
            // });

            that.$http.get('/v1/sSuppliers/public/checkLoginName/' + value + '/1').then(res => {
                // console.log('success,get',res)
                if (res.data.code == '1') {
                    !!fn && fn(res.data);
                } else {
                    // console.log('get',url)
                    that.$alert(res.data.msg, {
                        type: 'error',
                        callback: action => {
                            if (res.data.msg == 'token不能为空' || res.data.msg == 'token验证失败') {
                                if (!that.inLoginPage) {
                                    that.inLoginPage = true;
                                    that.$alert(res.data.msg, {
                                        type: 'error',
                                        callback: action => {
                                            let currentUrl = (window.location.href).split('?')[0];
                                            that.$router.push('/?currentUrl=' + encodeURIComponent(currentUrl));
                                        }
                                    })
                                }
                            } else {
                                that.$alert(res.data.msg, {
                                    type: 'error',
                                })
                            }
                        }
                    })
                }
            }).catch((err) => { //401,登录超时
                console.log('catch,get', err, url);
                if (err.response && err.response.status == '401') {
                    // console.log('get',that.isPopDialog)
                    if (that.isPopDialog) return; //如果为true，就不弹了
                    that.$alert('登录超时，请重新登录', {
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            let currentUrl = (window.location.href).split('?')[0];
                            that.$router.push('/login/' + encodeURIComponent(currentUrl));
                        }
                    })
                } else {
                    that.$alert('请求异常', {
                        type: 'error'
                    })
                }
                return;
            })
        },
        /*get或者post请求封装方法*/
        getHttp(url, successCallback) {
            let that = this;
            that.loading = true;
            that.$http.get(url).then(res => {
                that.loading = false;
                // console.log('success,get',res)
                if (res.data.code == '1') {
                    !!successCallback && successCallback(res);
                } else {
                    // console.log('get',url)
                    if (res.data.msg == 'token不能为空' || res.data.msg == 'token验证失败') {
                        if (!that.inLoginPage) {
                            that.inLoginPage = true;
                            that.$alert(res.data.msg, {
                                type: 'error',
                                callback: action => {
                                    let currentUrl = (window.location.href).split('?')[0];
                                    that.$router.push('/?currentUrl=' + encodeURIComponent(currentUrl));
                                }
                            })
                        }
                    } else {
                        that.$alert(res.data.msg, {
                            type: 'error',
                        })
                    }
                }
            }).catch((err) => { //401,登录超时
                console.log('catch,get', err, url);
                that.loading = false;
                if (err.response && err.response.status == '401') {
                    // console.log('get',that.isPopDialog)
                    if (that.isPopDialog) return; //如果为true，就不弹了
                    that.$alert('登录超时，请重新登录', {
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            let currentUrl = (window.location.href).split('?')[0];
                            // that.$router.push('/login/'+encodeURIComponent(currentUrl));
                            that.$router.push('/?currentUrl=' + encodeURIComponent(currentUrl));
                        }
                    })
                } else {
                    that.$alert('请求异常', {
                        type: 'error'
                    })
                }
                return;
            })
        },
        postHttp(url, data, successCallback, errorCallback) {
            let that = this;
            that.loading = true;
            that.$http.post(url, data).then(res => {
                that.loading = false;
                if (res.data.code == 1) {
                    // console.log('success',res)
                    !!successCallback && successCallback(res);
                } else {
                    // console.log('error',url)
                    if (res.data.msg == 'token不能为空' || res.data.msg == 'token验证失败') {
                        if (!that.inLoginPage) {
                            that.inLoginPage = true;
                            that.$alert(res.data.msg, {
                                type: 'error',
                                callback: action => {
                                    let currentUrl = (window.location.href).split('?')[0];
                                    that.$router.push('/?currentUrl=' + encodeURIComponent(currentUrl));
                                }
                            })
                        }
                    } else {
                        that.$alert(res.data.msg, {
                            type: 'error',
                            callback: action => {
                                !!errorCallback && errorCallback();
                            }
                        })
                    }
                }
            }).catch((err) => {
                console.log('post,catch', err)
                that.loading = false;
                if (err.response && err.response.status == '401') {
                    // console.log('post',that.isPopDialog)
                    if (that.isPopDialog) return; //如果为true，就不弹了
                    that.$alert('登录超时，请重新登录', {
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            let currentUrl = (window.location.href).split('?')[0];
                            // that.$router.push('/login/'+encodeURIComponent(currentUrl));
                            that.$router.push('/?currentUrl=' + encodeURIComponent(currentUrl));
                        }
                    })
                } else {
                    that.$alert('请求异常', {
                        type: 'error'
                    })
                }
                return;
            })
        },
        postFunc(url, data, successCallback, errorCallback) {
            this.postHttp(url, data, successCallback, errorCallback)
        },
        getFunc(url, successCallback) {
            this.getHttp(url, successCallback)
        },
        postHttpAddit(url, data, successCallback, errorCallback) {
            let that = this;
            that.loading = true;
            that.$http.post(url, data).then(res => {
                that.loading = false;
                !!successCallback && successCallback(res);
            }).catch((err) => {
                console.log('post,catch', err)
                that.loading = false;
                return;
            })
        },
        /*数组去重*/
        uniqueArr(arr) {
            let newArr = [];
            for (let i = 0; i < arr.length; i++) {
                if (newArr.indexOf(arr[i]) == -1) {
                    newArr.push(arr[i]);
                }
            }
            return newArr;
        },
        /*两个数组合并去重*/
        concatArr(arr1, arr2) {
            //不要直接使用var arr = arr1，这样arr只是arr1的一个引用，两者的修改会互相影响
            var arr = arr1.concat();
            //或者使用slice()复制，var arr = arr1.slice(0)
            for (var i = 0; i < arr2.length; i++) {
                arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0;
            }
            return arr;
        },
        /*下载文件*/
        downloadFile(formData) {
            let url = util.baseUrl + '/v1/public/download/download_direct?attachmentPath=' + formData.attachPath + '&attachmentName=' + encodeURIComponent(formData.attachName);
            window.location.href = url;
            // window.open(url,'_blank');
        },
        downloadFileByPath(filePath, fileName) {
            let that = this;
            if (!filePath) return false;
            that.$confirm('确定下载该附件吗?', {
                type: 'warning',
                callback: (action) => {
                    if (action == 'confirm') {
                        that.$root.downloadFile({
                            attachName: fileName,
                            attachPath: filePath
                        })
                    }
                }
            });
        },
        handleSelect(index) {
            // console.log(index);
            this.activeIndex = index
        },
        dateFormat(fmt, date) {
            if (!fmt) {
                return '';
            }
            var fDate = new Date(date);
            let ret;
            const opt = {
                "Y+": fDate.getFullYear().toString(), // 年
                "m+": (fDate.getMonth() + 1).toString(), // 月
                "d+": fDate.getDate().toString(), // 日
                "H+": fDate.getHours().toString(), // 时
                "M+": fDate.getMinutes().toString(), // 分
                "S+": fDate.getSeconds().toString() // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        },
        hasClass(el, className) {
            let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
            return reg.test(el.className)
        },
        addClass(el, className) {
            if (this.hasClass(el, className)) {
                return
            }
            if (el.className === '') {
                el.className += className
            } else {
                let newClass = el.className.split(' ')
                newClass.push(className)
                el.className = newClass.join(' ')
            }

        },
        removeClass(el, className) {
            if (this.hasClass(el, className)) {
                el.className = el.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), '');
            };
        }
    },
    created() {
        console.log('测试外网12345')
        this.uploadUrl = util.uploadUrl;
        this.downloadUrl = util.downloadUrl;
        this.baseUrl = util.baseUrl;
    }
});



// WEBPACK FOOTER //
// ./src/main.js